import React from 'react';
import _ from 'lodash';
import AccountLinkForm from '../../../../form/AccountLinkForm';
import AsyncActionButton from '../../../../button/AsyncActionButton';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import SearchBar from '../../../../searchbar/SearchBar';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import GrIntegrationService from '../../../../../service/GrIntegrationService';
import GRBlockGrantsDetailedAccountModal from './GRBlockGrantsDetailedAccountModal';
import GRBlockGrantsDetailedBill from './GRBlockGrantsDetailedBill';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import '../../../View.css';
import '../UtilityView.css';

class GRBlockGrants extends React.Component {
  constructor(props) {
    super(props);

    this.getBills = this.getBills.bind(this);

    this.comboFields = [
      {
        value: 'loanId',
        display: 'Loan Id',
      },
      {
        value: 'customerId',
        display: 'Customer Id',
      },
    ];

    this.state = {
      grid: null,
      isReady: false,
      billsReady: false,
      selectedAccountRow: null,
    };
  }

  GRBLOCKGRANTS = 'gr_block_grants';

  onAccountRowSelect(row) {
    this.setState({
      selectedAccountRow: row,
    });
  }

  getAccounts(criteria, onCompletion) {
    this.reset();

    GrIntegrationService.getGrBlockGrantsAccountBySearchCriteria(criteria)
      .then((response) => {
        const { accounts, } = response.data;

        const headers = Object.keys(accounts[0]).map(header => ({
          value: header,
          display: _.startCase(header),
        }));
        const rows = [];

        accounts.forEach((account) => {
          const row = Object.values(account);
          rows.push({ value: row, });
        });

        this.setState({
          grid: (
            <FieldSet title="Block Grants Accounts">
              <Grid
                headers={headers}
                rows={rows}
                onRowSelect={row => this.onAccountRowSelect(row)}
                onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
              />
            </FieldSet>
          ),
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        onCompletion();
        this.setState({ isReady: true, });
      });
  }

  getBills(id) {
    this.resetBill();

    const criteria = { accountId: id, };

    GrIntegrationService.getGrBlockGrantsBillByAccountId(criteria)
      .then((response) => {
        const { bills, } = response.data;

        const parsedBills = ObjectUtils.parseBills(bills);

        const billIndex = 0;
        this.setState({
          bill: parsedBills.parsedBills[billIndex],
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ billsReady: true, });
      });
  }

  formatAccountDetails = (account) => {
    if (!account) {
      return null;
    }

    const { isLoading, selectedAccountRow, } = this.state;

    return (
      <div className="container">
        <hr />
        <div className="row">
          <div className="p-2">
            <GRBlockGrantsDetailedAccountModal account={account} />
          </div>
          <div className="p-2">
            <AsyncActionButton
              onClick={() => {
                this.getBills(account.id);
              }}
              contents="Show Bills"
              isLoading={isLoading}
              variant="success"
              loadingVariant="secondary"
            />
          </div>
          <div className="p-2">
            <AccountLinkForm
              id={selectedAccountRow.id}
              serviceOfferingId={this.GRBLOCKGRANTS}
              customerIds={ObjectUtils.formatStringAsJSONArray(selectedAccountRow.customerIds)}
            />
          </div>
        </div>
      </div>
    );
  };

  formatSelectedAccountDisplay(account) {
    if (!account) {
      return null;
    }
    return <p>{`Selected account ID: ${account.id}`}</p>;
  }

  searchOnClick(event) {
    const { combo = {}, search = {}, } = event;
    const criteria = {};
    criteria[combo.value] = search.value;
    this.getAccounts(criteria, event.kill);
  }

  reset() {
    this.setState({
      bill: undefined,
      grid: null,
      isReady: false,
      billsReady: false,
      selectedAccountRow: null,
    });
  }

  resetBill() {
    this.setState({
      bill: undefined,
      billsReady: false,
    });
  }

  showAccounts() {
    const { isReady, grid, selectedAccountRow, } = this.state;

    if (isReady) {
      return (
        <>
          {grid}
          {this.formatSelectedAccountDisplay(selectedAccountRow)}
          {this.formatAccountDetails(selectedAccountRow)}
        </>
      );
    }

    return null;
  }

  showBills() {
    const { bill, billsReady, } = this.state;

    if (bill !== undefined && billsReady) {
      return <GRBlockGrantsDetailedBill bill={bill} />;
    }

    return null;
  }

  showLinkForm() {
    const { linkForm, } = this.state;
    this.setState({ linkForm: !linkForm, });
  }

  render() {
    const { billsReady, } = this.state;

    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={event => this.searchOnClick(event)} />
        <div className="row">
          <div className="col-12 p-3">{this.showAccounts()}</div>
          <div className="col-12 p-3">{billsReady ? this.showBills() : ''}</div>
        </div>
      </div>
    );
  }
}

export default GRBlockGrants;
